import { render } from "./ProfileClienteShow.vue?vue&type=template&id=760012b6&scoped=true"
import script from "./ProfileClienteShow.vue?vue&type=script&lang=js"
export * from "./ProfileClienteShow.vue?vue&type=script&lang=js"

import "./ProfileClienteShow.vue?vue&type=style&index=0&id=760012b6&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760012b6"]])

export default __exports__